import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const browserPopupSlice = createSlice({
  name: "browserPopup",
  initialState: {
    isBrowserPopupBlocked: false,
  },
  reducers: {
    setBrowserPopupBlocked: (state: any, action: PayloadAction<any>) => {
      state.isBrowserPopupBlocked = action.payload;
    },
  },
});

export const { setBrowserPopupBlocked } = browserPopupSlice.actions;
export default browserPopupSlice.reducer;
